import { types } from 'mobx-state-tree';

const FilterOptionModel = types.model('FilterOption', {
    id: types.string,
    value: types.string,
    title: types.string,
    name: types.string,
});

export default FilterOptionModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/FilterOptionModel.js